export class ViewerEditorIconsConstants {
  public static VIEWER_ICON  = '/assets/images/viewer_icon_bw.svg';
  public static EDITOR_ICON = '/assets/images/editor_icon_bw.svg';
  public static OWNER_ICON = '/assets/images/owner_icon_bw.svg';
  public static ADMIN_ICON = '/assets/images/admin_icon_bw.svg';
}
